<div *ngIf="currentUserMode == 'provider'">
  <div class="d-flex flex-column align-items-start align-self-stretch gap-4 p-3 w-100">
    <div class="page-header">
      <div class="page-header__text">
        <h1>Financial Dashboard</h1>
        <p>Your earnings, fees and payouts in one place.</p>
      </div>
      <!-- Mobile only: under the title (My Jobs pattern). Desktop keeps Export in the Sales toolbar. -->
      <button type="button" class="btn-export page-header__export" [disabled]="exporting" [attr.aria-busy]="exporting" title="Export Report to CSV" (click)="exportCsv()">
        Export CSV
        <span *ngIf="exporting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <img *ngIf="!exporting" src="assets/icons/data-table/download.svg" alt="" width="16" height="16" />
      </button>
    </div>

    <a class="notice" *ngIf="pendingCancellations > 0" [href]="cancellationUrl" target="_blank" rel="noopener">
      <img src="assets/icons/financials/cancellation-alert.svg" alt="" width="35" height="46" />
      <span>
        <strong>***You have 1 or more Pending Cancellations that require action.</strong>
        Respond now to avoid your account being limited. CLICK HERE***
      </span>
    </a>

    <div class="summary">
      <div class="stats">
        <article class="stat">
          <p class="stat-label">Net Earnings</p>
          <p class="stat-value" *ngIf="!summaryLoading; else skeleton">{{ money(netEarnings) }}</p>
          <p class="stat-note">After Truckit fees</p>
        </article>
        <article class="stat">
          <p class="stat-label">Pending Payout</p>
          <p class="stat-value" *ngIf="!summaryLoading; else skeleton">{{ money(pendingPayout) }}</p>
          <p class="stat-note">Awaiting transfer</p>
        </article>
      </div>
      <p class="summary-note">
        <span>
          Truckit Pay disbursements/payouts occur in batches, meaning a payment you receive in your bank may include funds for multiple completed jobs. Do you need to reconcile with your bank
          statement?
          <a [href]="helpUrl" target="_blank" rel="noopener">Learn more here.</a>
        </span>
      </p>
    </div>

    <ng-template #skeleton>
      <p class="stat-value stat-skeleton" aria-busy="true" aria-label="Loading"></p>
    </ng-template>

    <app-financial class="w-100"></app-financial>
  </div>
</div>
<div *ngIf="currentUserMode == 'customer'">
  <app-financial-report></app-financial-report>
</div>
